import { FaArrowLeft } from "react-icons/fa";

export default function DetailNotFound({
  icon: Icon,
  title = "Bulunamadı",
  message = "İstenen bilgilere ulaşılamadı.",
  backLabel = "Geri Dön",
  onGoBack,
}) {
  return (
    <div className="px-0 sm:px-4 sm:py-2">
      <div className="bg-white sm:rounded-2xl sm:shadow-lg sm:border sm:border-gray-200 p-12 text-center">
        {Icon && <Icon className="w-16 h-16 text-gray-300 mx-auto mb-4" />}
        <h2 className="text-xl font-bold text-gray-800 mb-2">{title}</h2>
        <p className="text-gray-500 mb-6">{message}</p>
        <button
          onClick={onGoBack}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-colors"
        >
          <FaArrowLeft className="w-4 h-4" />
          {backLabel}
        </button>
      </div>
    </div>
  );
}
